import { mutationOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import { getBaseTaskListQueryKey } from '../task/api';
import type { ProductAnalysisTaskDto } from '../task/model';
import type { ProductAnalysisInputDto } from './model';

export const analyzeProductMutationOptions = mutationOptions({
  mutationKey: [...getBaseTaskListQueryKey()],
  mutationFn: async (input: ProductAnalysisInputDto) => {
    return http
      .post('script/product', { json: input })
      .json<ProductAnalysisTaskDto>();
  },
});
